import PropTypes from 'prop-types';
import React from 'react';

import { performSelectApi } from '../../../action/performUserResourceActions';
import { useTranslation } from '../../hooks/useTranslation';
import styles from './styles.module.styl';

function ApiSelector({ handleSelected, createApiUrl, userApis, selectedApiId }) {
  const { t } = useTranslation('core');

  const handleChange = (e) => {
    const value = e.target.value;

    if (value === 'create_api') {
      const win = window.open(createApiUrl, '_blank');
      win.focus();
    } else if (value !== 'disabled') {
      handleSelected(performSelectApi, value);
    }
  };

  return (
    <div className={`${styles.formGroup} form-group`}>
      <label htmlFor="qs-download-modal-api" className="control-label">
        {t('quickstarts.downloadSampleModal.apiSelector.api', 'API')}
      </label>
      <select
        name="qs-download-modal-api"
        id="qs-download-modal-api"
        className="form-control"
        onChange={handleChange}
        value={userApis.length ? selectedApiId : 'disabled'}
      >
        {!userApis.length && [
          <option key="disabled" value="disabled" disabled>
            {t('quickstarts.downloadSampleModal.apiSelector.noApisAvailable', 'No APIs Available')}
          </option>,
          <option key="create_api" value="create_api">
            {t('quickstarts.downloadSampleModal.apiSelector.createApi', 'Create an API')}
          </option>,
        ]}

        {userApis.map((api) => (
          <option key={api.id} value={api.id}>
            {api.name}
          </option>
        ))}
      </select>
    </div>
  );
}

ApiSelector.propTypes = {
  handleSelected: PropTypes.func.isRequired,
  createApiUrl: PropTypes.string.isRequired,
  userApis: PropTypes.array.isRequired,
  selectedApiId: PropTypes.string,
};

export default ApiSelector;
